module.exports = __webpack_public_path__ + "static/img/Frame 1010104466@2x.9351747.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/Frame 1010104466@2x.png
// module id = PdO/
// module chunks = 1